
import * as types from '../mutation-types'
import contact from '@/api/contacts'

const state = {
  status: 'idle',
  error: null,
  message: null
}

const getters = {
  contactError: (state) => {
    return state.error
  },
  contactMessage: (state) => {
    return state.message
  },
  contactIsLoading: (state) => {
    return state.status === 'loading'
  }
}

// actions
const actions = {
  createContact ({ dispatch, commit, rootGetters }, email) {
    commit(types.CONTACT_CREATING)
    return new Promise((resolve, reject) => {
      const params = {
        email: email,
        user_agent: navigator.userAgent,
        referrer: document.referrer,
        path: window.location.href
      }
      contact.createContact(params).then((response) => {
        commit(types.CONTACT_CREATED, response.data.result.contact.email)
        resolve(response.data.contact)
      }).catch((err) => {
        commit(types.CONTACT_CREATE_ERROR, err.message.includes('contact already exists') ? 'This email has been registered already.' : err.message)
        reject(err)
      })
    })
  },
  validateEmail ({ commit }, email) {
    return new Promise((resolve, reject) => {
      const emailFormat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/
      if (email.match(emailFormat)) {
        commit(types.CONTACT_CREATE_ERROR_RESET)
        resolve(email)
      } else {
        commit(types.CONTACT_CREATE_ERROR, 'Please enter a valid email.')
        reject(new Error('invalid email.'))
      }
    })
  }
}

const mutations = {
  [types.CONTACT_CREATING] (state) {
    state.status = 'loading'
  },
  [types.CONTACT_CREATED] (state, data) {
    state.email = data.email
    state.status = 'loaded'
    state.message = 'You\'re all set! A confirmation has been sent to your email.'
  },
  [types.CONTACT_CREATE_ERROR] (state, error) {
    state.status = 'error'
    state.error = error
    state.message = null
  },
  [types.CONTACT_CREATE_ERROR_RESET] (state) {
    state.status = 'idle'
    state.error = null
    state.message = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
